module.exports = __webpack_public_path__ + "img/fourth-footer-icon.54d6e1ac.svg";